<app-modal-loading-overlay *ngIf="initialLoading"></app-modal-loading-overlay>
<div *ngIf="!initialLoading" class="p-3">
  <div class="d-flex justify-content-between align-items-center px-4 border-bottom w-100">
    <div class="d-flex flex-column">
      <h1 class="d-flex text-dark fw-bold my-1 fs-5">Agent Group Lookup</h1>
    </div>
    <div class="d-flex align-items-center py-2 py-md-1">
      <a (click)="activeModal.close()" class="p-3">
        <i class="fs-5 bi bi-x-lg fw-bold"></i>
      </a>
    </div>
  </div>
  <div class="bg-light w-100 mb-3">
    <app-loading-overlay *ngIf="loading"></app-loading-overlay>
    <div class="card-body">
      <h5 class="card-title mb-3 d-flex justify-content-between">
        <app-custom-search-widget [searchFields]="sortColumns" (onSearch)="search()"
          [paginationOptions]="paginationOptions"></app-custom-search-widget>
      </h5>
      <hr>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table align-middle table-hover table-row-dashed fs-8 no-footer">
            <thead>
              <tr class="text-start text-gray-800 fs-8 text-uppercase">
                <th class="pb-3 fw-bold">
                  <ng-template #agent_group_numberCol [ngTemplateOutlet]="agent_group_numberCol" let-field="field"
                    [ngTemplateOutletContext]="{ field: 'agent_group_number' }">
                    <a (click)="changeSort(field)" href="javascript:void(0)">Agent Group #
                      <i *ngIf="paginationOptions.sort === field"
                        class="bi ms-3 {{ paginationOptions.directionIsAsc() ? 'bi-sort-up' : 'bi-sort-down' }}"></i>
                    </a>
                  </ng-template>
                </th>
                <th class="pb-3 fw-bold">
                  <ng-template #company_nameCol [ngTemplateOutlet]="company_nameCol" let-field="field"
                    [ngTemplateOutletContext]="{ field: 'company_name' }">
                    <a (click)="changeSort(field)" href="javascript:void(0)">Agent Group Name
                      <i *ngIf="paginationOptions.sort === field"
                        class="bi ms-3 {{ paginationOptions.directionIsAsc() ? 'bi-sort-up' : 'bi-sort-down' }}"></i>
                    </a>
                  </ng-template>
                </th>
                <th class="pb-3 fw-bold">
                  <ng-template #detailsCol [ngTemplateOutlet]="detailsCol" let-field="field"
                    [ngTemplateOutletContext]="{ field: 'details' }">
                    <a (click)="changeSort(field)" href="javascript:void(0)">Details
                      <i *ngIf="paginationOptions.sort === field"
                        class="bi ms-3 {{ paginationOptions.directionIsAsc() ? 'bi-sort-up' : 'bi-sort-down' }}"></i>
                    </a>
                  </ng-template>
                </th>
                <th class="pb-3 fw-bold">
                  <ng-template #statusCol [ngTemplateOutlet]="statusCol" let-field="field"
                    [ngTemplateOutletContext]="{ field: 'status' }">
                    <a (click)="changeSort(field)" href="javascript:void(0)">Status
                      <i *ngIf="paginationOptions.sort === field"
                        class="bi ms-3 {{ paginationOptions.directionIsAsc() ? 'bi-sort-up' : 'bi-sort-down' }}"></i>
                    </a>
                  </ng-template>
                </th>
                <th class="pb-3 fw-bold text-end">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody class="fw-semibold text-gray-700">
              <tr *ngIf="agentGroupsList?.length === 0">
                <td colspan="100" class="py-5 text-center">No results found</td>
              </tr>
              <tr *ngFor="let agentGroup of agentGroupsList">
                <td>{{ agentGroup.agent_group_number }}</td>
                <td>{{ agentGroup.company_name | truncate }}</td>
                <td>{{ agentGroup.details ?? '--' | truncate }}</td>
                <td [innerHTML]="agentGroup.status | statusBadge | safe : 'html'"></td>
                <td class="d-flex justify-content-end">
                  <a (click)="select(agentGroup)" class="btn btn-light btn-lg me-2 fw-bold">
                    <i class="bi bi-check-square me-2 fw-semibold"></i> Select
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="d-flex justify-content-between">
            <div class="w-auto d-flex align-items-center" *ngIf="paginatedResults">
              <app-pagination-select [(ngModel)]="paginatedResults.per_page" [options]="[6,10,20,100, 500, 1000, 10000, 100000]"
                [selectedOption]="paginatedResults.per_page" (ngModelChange)="onPerPageChanged()">
              </app-pagination-select>
              <div class="px-2 fw-bold text-gray-700">
                <span *ngIf="paginatedResults.total != 0">
                  Showing {{ paginatedResults.to - paginatedResults.from + 1 }} of {{ paginatedResults.total }}
                  results
                </span>
              </div>
            </div>
            <div *ngIf="paginatedResults">
              <ngb-pagination [collectionSize]="paginatedResults.total" [(page)]="paginatedResults.current_page"
                [pageSize]="paginatedResults.per_page" [rotate]="true" [boundaryLinks]="true" [maxSize]="5"
                (pageChange)="onPageNumberChanged()">
                <ng-template ngbPaginationFirst>First</ng-template>
                <ng-template ngbPaginationLast>Last</ng-template>
                <ng-template ngbPaginationPrevious>Prev</ng-template>
                <ng-template ngbPaginationNext>Next</ng-template>
                <ng-template ngbPaginationEllipsis>...</ng-template>
                <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
